var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36902 10.0041C7.27429 10.1077 7.14038 10.1667 7 10.1667C6.85962 10.1667 6.72571 10.1077 6.63099 10.0041L3.96432 7.08738C3.77799 6.88358 3.79215 6.56732 3.99595 6.38099C4.19975 6.19465 4.51602 6.20881 4.70235 6.41262L6.5 8.3788V1C6.5 0.723858 6.72386 0.5 7 0.5C7.27614 0.5 7.5 0.723858 7.5 1V8.3788L9.29765 6.41262C9.48399 6.20881 9.80025 6.19465 10.0041 6.38099C10.2079 6.56732 10.222 6.88358 10.0357 7.08738L7.36902 10.0041Z",
    fill: "#4B4B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9C1.5 8.72386 1.27614 8.5 1 8.5C0.723859 8.5 0.5 8.72386 0.5 9V9.03658C0.499987 9.94831 0.499976 10.6832 0.577683 11.2612C0.658361 11.8612 0.830956 12.3665 1.23223 12.7678C1.63351 13.169 2.13876 13.3416 2.73883 13.4223C3.31681 13.5 4.05169 13.5 4.96342 13.5H9.03658C9.94831 13.5 10.6832 13.5 11.2612 13.4223C11.8612 13.3416 12.3665 13.169 12.7678 12.7678C13.169 12.3665 13.3416 11.8612 13.4223 11.2612C13.5 10.6832 13.5 9.94831 13.5 9.03658V9C13.5 8.72386 13.2761 8.5 13 8.5C12.7239 8.5 12.5 8.72386 12.5 9C12.5 9.95694 12.4989 10.6244 12.4312 11.1279C12.3655 11.6171 12.2452 11.8762 12.0607 12.0607C11.8762 12.2452 11.6171 12.3655 11.1279 12.4312C10.6244 12.4989 9.95695 12.5 9 12.5H5C4.04306 12.5 3.37565 12.4989 2.87208 12.4312C2.3829 12.3655 2.12385 12.2452 1.93934 12.0607C1.75483 11.8762 1.63453 11.6171 1.56877 11.1279C1.50106 10.6244 1.5 9.95694 1.5 9Z",
    fill: "#4B4B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.4680cab60d9d8fa58263b2a48a342dce.svg";
export { ForwardRef as ReactComponent };